import { ClassValue, clsx } from 'clsx';
import { ReadonlyURLSearchParams } from 'next/navigation';
import { twMerge } from 'tailwind-merge';

import { env } from '@/env.mjs';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(input: string | number): string {
  const date = new Date(input);
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
}

export function absoluteUrl(path: string) {
  return `${env.NEXT_PUBLIC_APP_URL}${path}`;
}

export function getBaseUrl() {
  return `${env.NEXT_PUBLIC_APP_URL}`;
}

export async function sleep(time: number) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

export function createUrl(
  pathname: string,
  params: URLSearchParams | ReadonlyURLSearchParams
) {
  const paramsString = params.toString();
  const queryString = `${paramsString.length ? '?' : ''}${paramsString}`;

  return `${pathname}${queryString}`;
}

export function capitalize(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function assertNever(_x: never): never {
  throw new Error('Unexpected value. Should have been never.');
}

export async function copy(text: string) {
  if (navigator && navigator.clipboard) {
    return navigator.clipboard.writeText(text);
  }
  throw new Error('Clipboard is not available');
}
